import styled from 'styled-components';
import { USER_TYPES, USER_TYPE_LABELS } from '../../../constants';

const Container = styled.div`
  margin-bottom: 16px;
`;

const Label = styled.label`
  display: block;
  margin-bottom: 6px;
  font-size: 14px;
  font-weight: 500;
  color: #333;
`;

const RadioGroup = styled.div`
  display: flex;
  gap: 16px;
  flex-wrap: wrap;
`;

const RadioLabel = styled.label`
  display: flex;
  align-items: center;
  cursor: pointer;
  padding: 10px 16px;
  border: 2px solid ${props => props.$checked ? '#007bff' : '#ddd'};
  border-radius: 4px;
  background-color: ${props => props.$checked ? '#e7f3ff' : 'white'};
  transition: all 0.3s ease;

  &:hover {
    border-color: #007bff;
  }
`;

const RadioInput = styled.input`
  margin-right: 8px;
  cursor: pointer;
`;

const RadioText = styled.span`
  font-size: 14px;
  color: #333;
  font-weight: ${props => props.$checked ? '600' : '400'};
`;

const ErrorMessage = styled.span`
  display: block;
  margin-top: 4px;
  font-size: 12px;
  color: #dc3545;
`;

const UserTypeSelect = ({ label = "사용자 유형", value, onChange, error, disabled = false }) => {
  const handleChange = (type) => {
    if (!disabled) {
      onChange(type);
    }
  };

  return (
    <Container>
      {label && <Label>{label}</Label>}
      <RadioGroup>
        <RadioLabel $checked={value === USER_TYPES.ADMIN}>
          <RadioInput
            type="radio"
            name="userType"
            value={USER_TYPES.ADMIN}
            checked={value === USER_TYPES.ADMIN}
            onChange={() => handleChange(USER_TYPES.ADMIN)}
            disabled={disabled}
          />
          <RadioText $checked={value === USER_TYPES.ADMIN}>
            {USER_TYPE_LABELS[USER_TYPES.ADMIN]}
          </RadioText>
        </RadioLabel>

        <RadioLabel $checked={value === USER_TYPES.MOM}>
          <RadioInput
            type="radio"
            name="userType"
            value={USER_TYPES.MOM}
            checked={value === USER_TYPES.MOM}
            onChange={() => handleChange(USER_TYPES.MOM)}
            disabled={disabled}
          />
          <RadioText $checked={value === USER_TYPES.MOM}>
            {USER_TYPE_LABELS[USER_TYPES.MOM]}
          </RadioText>
        </RadioLabel>

        <RadioLabel $checked={value === USER_TYPES.TEACHER}>
          <RadioInput
            type="radio"
            name="userType"
            value={USER_TYPES.TEACHER}
            checked={value === USER_TYPES.TEACHER}
            onChange={() => handleChange(USER_TYPES.TEACHER)}
            disabled={disabled}
          />
          <RadioText $checked={value === USER_TYPES.TEACHER}>
            {USER_TYPE_LABELS[USER_TYPES.TEACHER]}
          </RadioText>
        </RadioLabel>
      </RadioGroup>
      {error && <ErrorMessage>{error}</ErrorMessage>}
    </Container>
  );
};

export default UserTypeSelect;
